import uniq from 'lodash/uniq';

export const extractVariablesFromTemplate = (content) => {
  const variables = [];

  const parts = content.split('[[').slice(1);

  parts.forEach((part) => {
    const variable = part.split(']]')[0];

    if (variable) {
      variables.push(variable);
    }
  });

  // filter duplicates
  return uniq(variables);
};

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return undefined;
}
export function csrfToken() {
  return getCookie('XSRF-TOKEN');
}

export function isPositiveInteger(value) {
  const reg = /^\d+$/;
  if (!value || value < 1) {
    return false;
  }
  if (!reg.test(value)) {
    return false;
  }
  return true;
}

/**
 * Normalizes a string to be used as a field name or identifier
 * Converts to lowercase, trims whitespace, and replaces non-alphanumeric characters with underscores
 * @param {string} str - The string to normalize
 * @returns {string} - The normalized string
 */
export const normalizeFieldName = (str) => {
  return str.toLowerCase().trim().replace(/[^a-z0-9_]/g, '_');
};

export const sleep = (ms) => {
  return new Promise(resolve => {
    setTimeout(() => resolve(), ms);
  });
};
